const firebaseConfig = {
    apiKey: "AIzaSyAgsyCeqeYtwyGvFmbo2V4b8_ftx3Z5qfc",
    authDomain: "volunteer-network-demo.firebaseapp.com",
    databaseURL: "https://volunteer-network-demo.firebaseio.com",
    projectId: "volunteer-network-demo",
    storageBucket: "volunteer-network-demo.appspot.com",
    messagingSenderId: "1083056973466",
    appId: "1:1083056973466:web:4d4d9eceb96c24f5852123"
  };
  export default firebaseConfig;